import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IUserMe } from '@clickersphere/core/entities/IUserMe';
import UserService from '@clickersphere/core/services/UserService';

export const LOGGED_IN_USER_QUERY_KEY = ['users', 'me'];

export type UserMeQueryData = WithQueryStatus<IUserMe>;

export function useUserMe(checkAuthentication: boolean | undefined = true) {
  const {
    data: loggedInUser,
    isLoading: isLoggedInUserLoading,
    isError: isLoggedInUserError,
    isSuccess: isLoggedInUserSuccess,
  } = useQuery({
    queryKey: LOGGED_IN_USER_QUERY_KEY,
    queryFn: async () => {
      const user = await UserService.me();

      return user as UserMeQueryData;
    },
    staleTime: Infinity,
    enabled: checkAuthentication !== false,
  });

  return {
    loggedInUser,
    isLoggedInUserLoading,
    isLoggedInUserError,
    isLoggedInUserSuccess,
    selectedTenantId: loggedInUser?.selectedTenantId,
  };
}
